import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { MobileViewMessage } from "@limitless/portal";
import { useTranslation } from "@limitless/common/hooks";
import apple from "../assets/appstore-bg.svg";
import google from "../assets/googleplay-bg.svg";

const useStyles = makeStyles(() => ({
    logoContainer: {
        display: "flex",
        justifyContent: "center",
        padding: 15
    }
}));

const MobileViewScreen = ({ handleViewDesktopAnyway }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <MobileViewMessage
            showDesktopButton
            desktopButtonAction={handleViewDesktopAnyway}
            desktopButtonText={t("Proceed to Desktop")}
        >
            <Typography align="center">
                {t("We notice you're on a small screen device, why not download our mobile app instead")}
            </Typography>
            <a
                href="https://itunes.apple.com/gb/app/limitless-technology-ltd/id1169025075?mt=8"
                className={classes.logoContainer}
            >
                <img src={apple} />
            </a>
            <a
                href="https://play.google.com/store/apps/details?id=io.belimitless.expert"
                className={classes.logoContainer}
            >
                <img src={google} />
            </a>
        </MobileViewMessage>
    );
};

export default MobileViewScreen;

MobileViewScreen.propTypes = {
    handleViewDesktopAnyway: PropTypes.func.isRequired
};
